import appConfig from '../config/appConfig';

export const BILLING_MODE = {
  AUTO: 'AUTO',
  STANDARD: 'STANDARD',
  STANDARD_TARIFF: 'STANDARD_TARIFF',
  TIME_OF_USE: 'TIME_OF_USE',
};

const EXPLICIT_MODE_MAP = {
  auto: BILLING_MODE.AUTO,
  standard: BILLING_MODE.STANDARD,
  time_of_use: BILLING_MODE.TIME_OF_USE,
  timeofuse: BILLING_MODE.TIME_OF_USE,
  onpeak: BILLING_MODE.TIME_OF_USE,
  tou: BILLING_MODE.TIME_OF_USE,
  standard_tariff: BILLING_MODE.STANDARD_TARIFF,
  dependency_based: BILLING_MODE.STANDARD_TARIFF,
};

function normalizeConfiguredMode(mode = '') {
  const normalized = String(mode || '').trim().toLowerCase();
  return EXPLICIT_MODE_MAP[normalized] || BILLING_MODE.AUTO;
}

function getConfiguredMode(overrideMode) {
  if (overrideMode !== undefined && overrideMode !== null && overrideMode !== '') {
    return normalizeConfiguredMode(overrideMode);
  }

  if (typeof appConfig.getBillingMode === 'function') {
    return normalizeConfiguredMode(appConfig.getBillingMode());
  }

  return BILLING_MODE.AUTO;
}

function getConfiguredCapabilities(context = {}) {
  if (context.billingCapabilities) {
    return context.billingCapabilities;
  }

  if (typeof appConfig.getBillingCapabilities === 'function') {
    return appConfig.getBillingCapabilities();
  }

  return {};
}

export function resolveBillingMode(context = {}) {
  const configuredCapabilities = getConfiguredCapabilities(context);

  if (configuredCapabilities.timeOfUse === true) {
    return BILLING_MODE.TIME_OF_USE;
  }

  if (configuredCapabilities.timeOfUse === false) {
    return BILLING_MODE.STANDARD;
  }

  const configuredMode = getConfiguredMode(context.configMode);
  if (configuredMode !== BILLING_MODE.AUTO) {
    return configuredMode;
  }

  return BILLING_MODE.STANDARD;
}

export function isTimeOfUseBillingMode(mode = '') {
  const normalizedMode = String(mode || '').toUpperCase();
  return normalizedMode === BILLING_MODE.TIME_OF_USE;
}

export function isStandardTariffBillingMode(mode = '') {
  return String(mode || '').toUpperCase() === BILLING_MODE.STANDARD_TARIFF;
}
